import { db, auth } from '../config/firebase-config';
import { collection, query, where, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';


// Reference to the "users" collection in Firestore
const emailCollectionRef = collection(db, "mail");

// Create New Notification
export const sendEmail = ( formData ) => async dispatch => {

    const {
        type,  // String
        email,  // objectID
        message  // String
    } = formData;

    try {

        // --- Prepare the fields for the new email document

        const docFields = {};

        if(type === 'issue_reported') {
            docFields.to = email;
            docFields.message = {
                subject: `New Issue Reported by ${email}`,
                html: `
                    <div>
                        <h1 style="color:#333;font-size:20px">
                            A new issue has been submitted through the website.
                        </h1> 
                        <div>
                            <div style="color:#333333;margin-top:24px">
                                ~ ${email} wrote:
                            </div> 
                            <div style="padding:16px 24px;margin-top:12px;margin-bottom:24px;background-color:#f5f8fa;border-radius:5px;font-size:18px;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;color:#8899a6;font-weight:400;line-height:24px;text-align:left;word-break:break-word">
                                ${message}
                            </div> 
                        </div> 
                        <div style="font-size:12px;margin-top:32px;margin-bottom:42px;color:#888">
                            <div>
                                <a href="https://www.interviewcheater.com" style="color:inherit" target="_blank">
                                    <span class="il">
                                        InterviewCheater
                                    </span>
                                    .com
                                </a>
                                , is an undetectable desktop AI assistant.
                            </div>
                        </div>
                    </div>`,
            };
        }

        if(type === 'user_subscribed') {
            // TODO
        }

        docFields.date = Date.now();
        docFields.createdAt = serverTimestamp();

        // Add the new email document to the mail collection
        await addDoc(emailCollectionRef, docFields);

        // console.log('QUEUED EMAIL FOR DELIVERY!')

    } catch (err) {
        console.log('ERROR CODE 417!!!');
        // console.log(err);
    }
};